<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0px;">‘Harvey Winchester’ is the pseudonym of television producer RICHARD BATES, whose many productions include ‘The Darling Buds of May’ and ‘A Touch of Frost’.</p><br/>
<p style="text-indent:0px;">This is his first novel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?9b6c9730